<template>
    <goods-level :type="1"></goods-level>
</template>

<script>
    import GoodsLevel from '../goods/level.vue'

    export default {
        name: 'personGoodsLevel',
        components: {
            GoodsLevel
        },
        data() {
            return {
            }
        },
        mounted() {
            
        },
        methods: {
        }
    }
</script>
